<ui-grid [data]="data$ | async"
         [selectable]="false"
         [loading]="loading$ | async">
    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>

        <ui-header-button type="main">
            <ng-template>
                <a [matTooltip]="'logs_grid_action_export' | translate"
                   [uiClickTrack]="'Action: Download Logs'"
                   (click)="downloadReport($event)"
                   color="primary"
                   mat-mini-fab
                   target="report">
                    <mat-icon>file_download</mat-icon>
                </a>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>
    <ui-grid-column [sortable]="true"
                    [title]="'logs_grid_time' | translate"
                    property="time"
                    sort="desc"
                    width="10%">
        <ui-grid-dropdown-filter [items]="intervals"
                                 [value]="intervalValueFor(Interval.Day)"
                                 method="ge">
        </ui-grid-dropdown-filter>

        <ng-template let-index="index"
                     let-entry="data">
            <span *ngIf="entry.time"
                  uiDateFormat
                  [date]="entry.time"
                  titleType="relative"></span>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [sortable]="true"
                    [title]="'logs_grid_level' | translate"
                    property="level"
                    width="10%">
        <ui-grid-dropdown-filter [items]="logLevels"
                                 [showAllOption]="false"
                                 [value]="defaultLogLevel"
                                 method="ge">
        </ui-grid-dropdown-filter>
        <ng-template let-entry="data">
            <ng-container *ngLet="('LogLevel_' + entry.level) | translate as levelText">
                <span [matTooltip]="levelText">
                    {{levelText}}
                </span>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column *ngIf="entityType !== LogEntityType.Job"
                    [visible]="false"
                    [title]="'logs_grid_machine' | translate"
                    property="machineId">
        <ui-grid-search-filter [searchSourceFactory]="machineNameSuggest"
                               [disabled]="!(isMachinesViewGranted$ | async)"
                               property="machineId">
        </ui-grid-search-filter>
    </ui-grid-column>
    <ui-grid-column [searchable]="true"
                    [title]="'logs_grid_process' | translate"
                    property="processName"
                    width="10%">
        <ui-grid-search-filter [visible]="entityType !== LogEntityType.Job"
                               [searchSourceFactory]="processNameSuggest"
                               [disabled]="!(isProcessesViewGranted$ | async)"
                               property="processName">
        </ui-grid-search-filter>
    </ui-grid-column>
    <ui-grid-column [title]="'logs_grid_machine' | translate"
                    property="machineName"
                    width="10%">
    </ui-grid-column>
    <ui-grid-column [searchable]="true"
                    [title]="'logs_grid_user' | translate"
                    property="user"
                    width="15%">
        <ui-grid-search-filter [visible]="entityType === LogEntityType.None"
                               [searchSourceFactory]="usernameSuggest"
                               [disabled]="!(isRobotsViewGranted$ | async)"
                               property="user">
        </ui-grid-search-filter>
    </ui-grid-column>
    <ui-grid-column [searchable]="true"
                    [title]="'logs_grid_message' | translate"
                    property="message"
                    width="35%">
    </ui-grid-column>
    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button [matTooltip]="'logs_grid_action_view_details' | translate"
                    [uiClickTrack]="'Action: Grid: View Details'"
                    (click)="showDetails(entry)"
                    mat-icon-button
                    type="button">
                <mat-icon svgIcon="uipath:info"></mat-icon>
            </button>
        </ng-template>
    </ui-grid-row-action>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
<!-- FIXME: figure out how to display this better 😊 -->
<ng-container *ngLet="{
    current: total$ | async,
    actual: realCount$ | async
} as count">
    <mat-hint *ngIf="10000 < count.actual"
              color="warn"
              translate
              [translateParams]="{
                  displayedCount: count.current,
                  realCount: count.actual
              }">
        logs_page_elastic_warning
    </mat-hint>
</ng-container>
